import React, { useState, useRef } from 'react'
import { Container } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
  const form = useRef();
  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Message, setMessage] = useState('');
  const sendEmail = (e) => {
    e.preventDefault();
    setName('');
    setEmail('');
    setMessage('');
    toast.success('Message Sent Sucessfully !')
  };
  return (
    <Container className='pb-5'>
    <div className='contact-us'>
        <h3 className='pb-4'>Let's get in touch</h3>
          <form 
            ref={form} onSubmit={sendEmail}
            style={{display: 'flex', flexDirection: 'column', gap:'3rem'}}>
            <input className='ps-3'
              type="text"
              name="Name"
              value={Name}
              placeholder="Name"
              autoComplete="off"
              required
              onChange={(e) => setName(e.target.value)}
            />

            <input className='ps-3'
              type="email"
              name="Email"
              value={Email}
              placeholder="Email"
              autoComplete="off"
              required
              onChange={(e) => setEmail(e.target.value)}
            />

            <textarea className='ps-3 pt-2'
              style={{maxHeight:"100px", minHeight: "30px"}}
              name="message"
              value={Message}
              cols="30"
              rows="6"
              autoComplete="off"
              placeholder="Message"
              required
              onChange={(e) => setMessage(e.target.value)}></textarea>

            <input type="submit" value="Send Message" />
          </form>
    </div>
    <ToastContainer
     theme='dark'/>
    </Container>
  )
};
export default Contact;